/**
 * Stable CSS class names for E2E — ScheduleCreate Body tab.
 */
export const SCB = {
    root: 'schedule-body-tab',
    bodyInput: 'schedule-body-tab-input__body',
} as const;

export const scbCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

